import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface CertErrorInfo {
  serial: string;
  errorCount: number;
}

interface CertStoreState {
  certErrorInfoList?: CertErrorInfo[];

  clearErrorInfoList: () => void;

  getErrorInfo: (serial: string) => CertErrorInfo | undefined;
  increaseErrorCount: (serial: string) => CertErrorInfo;
  clearErrorCount: (serial: string) => void;
}

/**
 * 인증서정보 store
 */
export const useCertStore = create<CertStoreState>()(
  persist(
    (set, get) => ({
      // 인증서 오류정보
      certErrorInfoList: undefined,

      // 전체 인증서 오류 정보 초기화
      clearErrorInfoList: () => set({ certErrorInfoList: undefined }),

      // 에러정보 가져오기
      getErrorInfo: (serial) => {
        const list = get().certErrorInfoList;

        if (!list) {
          return;
        }

        return list.find((item) => item.serial === serial);
      },

      // 인증서 에러 카운트 증가
      increaseErrorCount: (serial) => {
        const list = get().certErrorInfoList ?? [];
        const targetItem = list.find((item) => item.serial === serial);

        let updated: CertErrorInfo;

        if (targetItem) {
          // 해당인증서 정보가 이미 존재하면

          updated = { ...targetItem, errorCount: targetItem.errorCount + 1 }; // 해당 인증서 에러 카운트 증가
          set({
            certErrorInfoList: list.map((item) => (item.serial === serial ? updated : item)),
          });
        } else {
          // 해당인증서 정보가 없다면

          updated = { serial, errorCount: 1 }; // 인증서 에러정보 초기 설정
          set({ certErrorInfoList: [...list, { serial, errorCount: 1 }] });
        }

        return updated;
      },

      // 인증서 에러 카운트 초기화
      clearErrorCount: (serial) => {
        const list = get().certErrorInfoList;

        if (!list) {
          return;
        }

        set({
          certErrorInfoList: list.map((item) =>
            item.serial === serial ? { ...item, errorCount: 0 } : item,
          ),
        });
      },
    }),
    {
      name: 'cert-storage', // 세션스토리지에 저장될 키 이름
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        certErrorInfoList: state.certErrorInfoList,
      }),
    },
  ),
);
